/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardQuotesRouteImport } from './routes/_dashboard.quotes'
import { Route as DashboardProfileRouteImport } from './routes/_dashboard.profile'
import { Route as DashboardLeadsRouteImport } from './routes/_dashboard.leads'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard.dashboard'
import { Route as DashboardClientsRouteImport } from './routes/_dashboard.clients'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'

const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardQuotesRoute = DashboardQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLeadsRoute = DashboardLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardClientsRoute = DashboardClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof AuthLoginRoute
  '/clients': typeof DashboardClientsRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/leads': typeof DashboardLeadsRoute
  '/profile': typeof DashboardProfileRoute
  '/quotes': typeof DashboardQuotesRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof AuthLoginRoute
  '/clients': typeof DashboardClientsRoute
  '/dashboard': typeof DashboardDashboardRoute
  '/leads': typeof DashboardLeadsRoute
  '/profile': typeof DashboardProfileRoute
  '/quotes': typeof DashboardQuotesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_dashboard/clients': typeof DashboardClientsRoute
  '/_dashboard/dashboard': typeof DashboardDashboardRoute
  '/_dashboard/leads': typeof DashboardLeadsRoute
  '/_dashboard/profile': typeof DashboardProfileRoute
  '/_dashboard/quotes': typeof DashboardQuotesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/clients'
    | '/dashboard'
    | '/leads'
    | '/profile'
    | '/quotes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/clients'
    | '/dashboard'
    | '/leads'
    | '/profile'
    | '/quotes'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dashboard'
    | '/_auth/login'
    | '/_dashboard/clients'
    | '/_dashboard/dashboard'
    | '/_dashboard/leads'
    | '/_dashboard/profile'
    | '/_dashboard/quotes'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/quotes': {
      id: '/_dashboard/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof DashboardQuotesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/profile': {
      id: '/_dashboard/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/leads': {
      id: '/_dashboard/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof DashboardLeadsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/dashboard': {
      id: '/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardDashboardRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/clients': {
      id: '/_dashboard/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof DashboardClientsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardRouteChildren {
  DashboardClientsRoute: typeof DashboardClientsRoute
  DashboardDashboardRoute: typeof DashboardDashboardRoute
  DashboardLeadsRoute: typeof DashboardLeadsRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardQuotesRoute: typeof DashboardQuotesRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardClientsRoute: DashboardClientsRoute,
  DashboardDashboardRoute: DashboardDashboardRoute,
  DashboardLeadsRoute: DashboardLeadsRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardQuotesRoute: DashboardQuotesRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
